import { getToken } from "@/utils/auth"
import { useStore } from "@/store"
import LoginPage from "@/core/auth/pages/LoginPage"
import React from "react"
import { Navigate, Route, Routes } from "react-router-dom"

const AuthRoutes: React.FC = () => {
  const token = getToken()
  const isStaff = useStore((state) => state.isStaff)

  if (token) {
    return (
      <Routes>
        <Route
          element={
            <Navigate
              to={isStaff ? "/dashboard" : "/dashboard/client-dashboard"}
              replace
            />
          }
          path="*"
        />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<LoginPage />} path="/" />
    </Routes>
  )
}

export default AuthRoutes
